module.exports = __webpack_public_path__ + "static/media/1.46f97dde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/3008/1.jpg
// module id = 640
// module chunks = 0